export default {

}

export const teacherPanelCardSettings = {
    getCardSettings: { method: 'get', url: 'teacher/panel-card-settings' },
    getActivePopups: { method: 'get', url: 'teacher/panel-popups/active' },
    markPopupAsRead: { method: 'post', url: 'teacher/panel-popups/{id}/read' },
}